<app-subnavegacion
  opcion1="renac"
  opcion2="renap"
></app-subnavegacion>

<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#ee0909"
  type="ball-atom"
  [fullScreen]="true"
>
  <p style="color: white">cargando ....</p>
</ngx-spinner>
<div class="panel mt-5">
  <div class="row">
    <div class="container">
      <div class="col-sm-12">
        <img src="./assets/images/Elementos/Carruse01.jpg" class="carrucel" />
      </div>
    </div>
    <br />
  </div>
  <div class="row">
    <div class="container">
      <div class="col-sm-1"></div>
      <div class="col-sm-10 leyenda1">
        <p>RENEC – Registro Nacional de Estándares de Competencia</p>
      </div>
    </div>
  </div>

  <div class="panel">
    <div class="row">
      <div class="container">
        <div class="col-sm-1">
          <br />
          &nbsp;
          <span
            ><img src="./assets/images/icon/lupa.png" class="iconLupa"
          /></span>
        </div>
        <div class="col-sm-11">
          <mat-form-field appearance="standard">
            <mat-label> Buscar</mat-label>
            <input
              matInput
              (keyup)="applyFilter($event)"
              placeholder="Buscar"
              #input
              oninput="this.value = this.value.toUpperCase()"
            />
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="container">
        <div class="col-sm-3">
          <button
            mat-raised-button
            (click)="
              exporter.exportTable('xlsx', {
                fileName: 'renec',
                sheet: 'datos',
                Props: { Author: 'conocer' }
              })
            "
          >
            Exportar a Excel
          </button>
        </div>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="container">
        <div class="col-sm-12 example-container">
          <div class="mat-elevation-z8">
            <table
              mat-table
              [dataSource]="dataSource"
              matTableExporter
              #exporter="matTableExporter"
              class="table table-striped table-bordered"
            >
              <ng-container matColumnDef="codigoE">
                <th mat-header-cell *matHeaderCellDef class="letraD marcaAgua">
                  Código
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  (click)="sectorByID(element)"
                  class="letraE"
                >
                  {{ element.codigo }}
                </td>
              </ng-container>

              <ng-container matColumnDef="nivelE">
                <th mat-header-cell *matHeaderCellDef class="letraD marcaAgua">
                  Nivel
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  (click)="sectorByID(element)"
                  class="letraE"
                >
                  {{ element.nivel }}
                </td>
              </ng-container>

              <ng-container matColumnDef="tituloE">
                <th mat-header-cell *matHeaderCellDef class="letraD marcaAgua">
                  Título
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  (click)="sectorByID(element)"
                  class="letraE"
                >
                  {{ element.titulo }}
                </td>
              </ng-container>
              <ng-container matColumnDef="comiteE">
                <th mat-header-cell *matHeaderCellDef class="letraD marcaAgua">
                  Comité
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  (click)="sectorByID(element)"
                  class="letraE"
                >
                  {{ element.comite }}
                </td>
              </ng-container>

              <ng-container matColumnDef="nbSectorE">
                <th mat-header-cell *matHeaderCellDef class="letraD marcaAgua">
                  Sector Productivo
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  (click)="sectorByID(element)"
                  class="letraE"
                >
                  {{ element.secProductivo }}
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
            <br />
          </div>
        </div>
      </div>

      <div class="container">

      
        <mat-paginator
        [pageSize]="30"
          showFirstLastButtons
          aria-label="Select page of periodic elements"
        >
        </mat-paginator>
      </div>
    </div>
    <br />
    <br />
  </div>
</div>
